import React, { useEffect, useState, Fragment, useContext, useRef } from 'react';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import { Button } from 'react-bootstrap';
import Images from 'assets/images/imageData';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import ModalPop from 'components/sales/modal/modal';
import { Link } from 'react-router-dom';
import FormSection from 'components/sales/formSection/formSection';
import Regex from 'services/utils/regex/Regex';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import DocumentView from 'components/sales/downloadDocView/documentView';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import Checkbox from 'components/sales/Input/checkbox/checkbox';
import DistanceCalculator from "../../DistanceCalculator/Calculator";
import {toast} from "react-toastify";
import TableSection from "../../../components/sales/tableSection/tableSection";
import {
  canShowGenerateReport,
  getReportPendingMessage,
  isReportComplete,
  shouldShowReportAttachment,
  shouldShowReportPending,
} from 'services/utils/reportUrl/reportUrl';

const CivilCheckout = ({
  match,
  location,
  getMaterialDelivery,
  materialData,
  postMaterialDelivery,
  updateStatus,
  getSiteInspect,
  generateReport,
  getPocBySiteId,
  pocListBySiteId,
  siteData,
  userProfile,
  postSendReportMail,
  calculateDistance,
  engDistanceData,
  siteDetails,
  getDistanceData,
  distanceDetails,
  getSiteData
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [formData, setFormData] = useState({
    site_id: match.params.id,
    invoice_no: '',
    challan_no: '',
    remark: '',
    data: [],
  });
  const [isFiled, setIsFiled] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [statusModal, setStatusModal] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDefalut, setIsDefalut] = useState(false);
  const openHideModal = () => setOpenModal(false);
  const [poclist, setPocList] = useState([]);
  const [showOtherEmail, setShowOtherEmail] = useState(false);
  const [mailList, setMailList] = useState([]);
  const [otherEmail, setOtherEmail] = useState();
  const [modal, setModal] = useState(false);
  const emailModalHide = () => setModal(false);
  const [showComplete, setShowComplete] = useState(false);
  const [showSubmit, setShowSubmit] = useState(false);
  const [isRecQntyValid, setIsRecQntyValid] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [isSubmitEnable, setSubmitEnable] = useState(false);
  const [role, setRole] = useState('');
  const [listData, setListData] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [channelPartner, setChannelPartner] = useState(null);
  const hasTriggeredGenerateReport = useRef(false);
  const [reportGenerationSubmitted, setReportGenerationSubmitted] = useState(false);

  const isReportPending = shouldShowReportPending(
    siteData,
    match.params.stageId,
    reportGenerationSubmitted
  );
  const reportPendingMessage = getReportPendingMessage();

  useEffect(() => {
    if (isReportComplete(siteData, match.params.stageId)) {
      setReportGenerationSubmitted(false);
    }
  }, [siteData?.report_url, siteData?.report_status, match.params.stageId]);

  const Headers = [
    'Shipment No.',
    'Date',
    'Status',
    'Completed Date',
    'Actions',
  ];

  useEffect(() => {
    const tableData = [
      'id',
      'challan_id',
      'created_at',
      'status',
      'completed_at'
    ];
    if (materialData) {

      const data =
      materialData?.resultSets?.length &&
        materialData.resultSets.map((element) =>
          Object.assign(
            {},
            ...tableData.map((key) => (
              {[key]: element[key]})),
              (element['status'] !== 'Completed') ?
              {
                Action:
                  [
                    /*{
                      name: 'View Details',
                      link: `${baseUrl}/brand-activation/carnival/details`,
                    },*/
                    {
                      name: 'Receive Material',
                      link: `${baseUrl}/receive-material`,
                    }
                  ]
              }
              :
              {
                
                      name: 'Received',
                    
              }
          )
        );
      console.log(materialData)
      if(materialData?.submitEnable){
        setSubmitEnable(materialData.submitEnable);
      }
      if (materialData?.resultSets?.length && data) {
        // toast.info('data found!');
        setListData(data);
        setPageCount(Math.ceil(materialData.total / materialData.per_page));
      } else {
        setListData([]);
        // toast.error('No data found!');
      }
    }
  }, [materialData, baseUrl]);

  useEffect(() => {
    let roles = JSON.parse(localStorage.getItem('roles'))
    setRole(roles[0]?.id)
    setIsOpen(!isOpen);
  }, [])

  useEffect( () => {
    (async () => {
      await getDistanceData(match.params.id, 'material-delivery')
    })()
  }, [])

  useEffect( () => {
    setIsOpen(true)
    if(distanceDetails !== {} && Object.keys(distanceDetails).length > 0){
      if(!distanceDetails['total_hours']){
        setIsOpen(false);
      }
    }
  }, [distanceDetails])

  useEffect( () => {
    if(engDistanceData !== null && Object.keys(engDistanceData).length > 0){
      toast.success('Distance is successfully fetched');
      setIsOpen(false);
      Object.keys(engDistanceData).forEach(key => {
        delete engDistanceData[key];
      })
    }else if(engDistanceData === null){
      toast.success('Distance is not fetched');
      setIsOpen(true);
    }
  }, [engDistanceData])

  useEffect(() => {
    if (getMaterialDelivery !== null && match.params.id);
    (async () => {
      setIsLoading(true);
      await getMaterialDelivery(match.params.id);
      await getSiteInspect(match.params.id, match.params.stageId);
      await getPocBySiteId(match.params.id);
      setIsLoading(false);
    })();
  }, [getMaterialDelivery, match.params.id]);

  useEffect(() => {
    if(siteData && siteData?.channel_partner_id){
      setChannelPartner(siteData.channel_partner_id);
    }
    (async () => {
      if (
        siteData &&
        siteData.hasOwnProperty('report_url') &&
        location.state?.status === 'Completed'
      ) {
        if (
          canShowGenerateReport(
            siteData,
            match.params.stageId,
            reportGenerationSubmitted
          ) &&
          !hasTriggeredGenerateReport.current
        ) {
          hasTriggeredGenerateReport.current = true;
          const data = {
            site_id: match.params.id,
            stage_id: match.params.stageId,
          };
          setIsLoading(true);
          const res = await generateReport(data);
          setIsLoading(false);
          if (res?.success) {
            setReportGenerationSubmitted(true);
          }
          await getSiteInspect(match.params.id, match.params.stageId);
        }
      }
    })();
  }, [siteData]);

  const handleSubmit = async () => {
    if (
      isRecQntyValid !== '' ||
      formData.site_id === '' ||
      formData.invoice_no === '' ||
      formData.challan_no === '' ||
      // formData.remark === '' ||
      formData.data.length <= 0 ||
      (formData && formData.data && formData.data[0].quantity === '')
    ) {
      setIsFiled(true);
      setIsModal(false);
    } else {
      setIsLoading(true);
      const res = await postMaterialDelivery(formData);
      setIsLoading(false);
      if (res === true) {
        setIsModal(true);
        setIsError(false);
        getMaterialDelivery(match.params.id);
      } else setIsError(true);
    }
  };

  const handleMaterialData = (val) => {
    if (val !== undefined && val !== null) {
      if (formData.data && formData.data.length === 0) {
        formData.data.push(val);
        setFormData({
          ...formData,
          data: [...formData.data],
        });
      } else {
        const isThere = formData.data.findIndex(
          (obj) => obj.material_id === val.material_id
        );
        if (isThere === -1) {
          formData.data.push(val);
          setFormData({
            ...formData,
            data: [...formData.data],
          });
        } else {
          formData.data.splice(isThere, 1);
          formData.data.push(val);
          setFormData({
            ...formData,
            data: [...formData.data],
          });
        }
      }
    }
  };

  const handleModalHide = () => {
    setIsModal(false);
    setIsDefalut(true);
  };

  const setToDefaultValue = () => {
    if (isDefalut === true) {
      setFormData({
        ...formData,
        site_id: '',
        invoice_no: '',
        challan_no: '',
        remark: '',
        data: [],
      });
    }
  };

  useEffect(() => setToDefaultValue(), [isDefalut]);

  const handleStatusUpdate = async (isCP) => {
    const res = await updateStatus(match.params.id, match.params.stageId,isCP);
    if (res === true) {
      setStatusModal(true);
    }
  };

  const sendMail = (val) => {
    if (val) {
      setOpenModal(true);
    }
  };

  const sendMailPoc = async () => {
    const findIndex =
      mailList &&
      mailList.length > 0 &&
      mailList.findIndex((el) => el === 'Others');
    if (findIndex !== -1) {
      mailList.splice(findIndex, 1);
      mailList.push(otherEmail);
      setMailList([...mailList]);
    }
    const data = {
      stage_id: match.params.stageId,
      site_id: match.params.id,
      pocs: mailList,
    };
    if (data.pocs.length > 0) {
      setIsLoading(true);
      const res = await postSendReportMail(data);
      setIsLoading(false);
      if (res === true) {
        openHideModal();
        setModal(true);
      }
    }
  };

  useEffect(() => {
    (() => {
      if (
        poclist &&
        poclist.length > 0 &&
        poclist.some((obj) => obj.id === 'Others')
      ) {
        setShowOtherEmail(true);
      } else {
        setShowOtherEmail(false);
      }
    })();
  }, [poclist]);

  useEffect(() => {
    let count = 0;
    if (materialData && materialData.length > 0) {
      materialData.map((obj) => {
        if (Number(obj.requested_quantity) <= Number(obj.receive_quantity)) {
          count++;
        }
      });
      if (count === materialData.length) {
        setShowComplete(true);
      }
    }
  }, [materialData]);

  useEffect(() => {
    const list =
      poclist && poclist.length > 0 && poclist.map((element) => element['id']);
    setMailList(list);
  }, [poclist]);

  const headerBtns = () => {
    return (
      <Fragment>
        {showComplete ? (
          <Button
            className="btn btn-primary"
            onClick={() => handleStatusUpdate()}
          >
            {localization.stageCompleted}
          </Button>
        ) : (
          <Button onClick={() => handleSubmit()} className="btn btn-primary">
            {localization.submit}
          </Button>
        )}
      </Fragment>
    );
  };
  const headerBtnsNew = () => {
    return (
      <Fragment>
        {/* channelPartner */}
        {channelPartner ? (
          <Button
          className="btn btn-primary"
          onClick={() => handleStatusUpdate(1)}
          >
            {`SKIP`}
          </Button>
        ): 
        isSubmitEnable ? (
          <Button
            className="btn btn-primary"
            onClick={() => handleStatusUpdate(0)}
          >
            {localization.stageCompleted}
          </Button>
        ) : (
          <span style={{ color: 'red' }}>Please Receive All Shipment</span>
        )
        }
      </Fragment>
    );
  };

  useEffect(() => {
    if (materialData && materialData.length > 0) {
      materialData.map((obj) => {
        if (Number(obj.requested_quantity) > Number(obj.receive_quantity)) {
          setShowSubmit(true);
        }
      });
    }
  }, [materialData]);
  return (
    <Layout
      title={localization.materialDelivery}
      Buttons={
        location.state && location.state.status !== 'Completed' && headerBtnsNew
      }
      className={isFiled ? 'requiredFileds' : ''}
      isGoback
      linkFlag={true}
      linkUrl={`/dashboard/site-stage/${match.params.id}`}
      isLoading={isLoading}
    >
      {role === 9 && isOpen ?
          <div className="popup-box">
            <div className="box">
              {siteDetails?.lead_id !== undefined &&
                  <Link
                      to={`${baseUrl}/site-stage/${match.params.id}/${siteDetails?.lead_id}`}
                      className="btn btn-primary mb-4"
                      style={{
                        'cursor': 'pointer',
                        'border': '0px',
                        'box-shadow': 'none !important',
                        'position': 'relative',
                        'top': '-17px',
                        'float':'right'
                      }}
                  >
                    x
                  </Link>
              }

              <DistanceCalculator
                  siteData={siteDetails}
                  getSiteData={getSiteData}
                  calculateDistance={calculateDistance}
                  siteId={match.params.id}
                  moduleType={'material-delivery'}
                  to={`${baseUrl}/site-stage/${match.params.id}/${siteDetails?.lead_id}`}
              />
            </div>
          </div> :
      <>

              {/* Transfer shipment */}
              {materialData?.resultSets?.length > 0 && (
                <>
                  {console.log(listData)}
                  <TableSection
                    data={listData}
                    headers={Headers}
                    detailList={materialData?.resultSets}
                    isId={false}
                    pageCount={pageCount}
                    srNo={materialData?.from}
                  />

                </>
              )}
              

              {/* End Transfer shipment */}
              {/* Old Material Delivery */}
              {/* <>
                  {
                    location.state && location.state.status !== 'Completed' ? (
                        <FormSection title={localization.material}>
                          <div className="panel-body">
                            {showSubmit === true && (
                                <Fragment>
                                  <ConstantInput
                                      label={localization.invoiceNo}
                                      isStarRequired={true}
                                      handleChange={(val) => {
                                        setFormData({
                                          ...formData,
                                          invoice_no: val,
                                          site_id: match.params.id,
                                        });
                                      }}
                                      required
                                      errorMsg={localization.isRequired}
                                  />
                                  <ConstantInput
                                      label={localization.challanNo}
                                      isStarRequired={true}
                                      handleChange={(val) => {
                                        setFormData({
                                          ...formData,
                                          challan_no: val,
                                        });
                                      }}
                                      required
                                      errorMsg={localization.isRequired}
                                  />
                                  <ConstantInput
                                      label={localization.remarks}
                                      isStarRequired={false}
                                      handleChange={(val) => {
                                        setFormData({
                                          ...formData,
                                          remark: val,
                                        });
                                      }}
                                      // required
                                      errorMsg={localization.isRequired}
                                  />
                                </Fragment>
                            )}

                            <table className="panel-table faq-listing">
                              <thead>
                              <tr>
                                <th>{localization.productName}</th>
                                <th>{localization.productCode}</th>
                                <th>{localization.requestedQuantity}</th>
                                <th>{localization.deliveredQuantity}</th>
                                {showSubmit === true && (
                                    <th>{localization.receiveQuantity}</th>
                                )}
                              </tr>
                              </thead>
                              <tbody>
                              {materialData &&
                                  materialData.length > 0 &&
                                  materialData.map((obj, index) => {
                                    return (
                                        <tr key={index}>
                                          <td>
                                            <span className="th">{localization.productName}</span>
                                            {obj.item_name}
                                          </td>
                                          <td>
                                            <span className="th">{localization.productCode}</span>
                                            {obj.item_code_id}
                                          </td>
                                          <td>
                                  <span className="th">
                                    {localization.requestedQuantity}
                                  </span>
                                            {obj.requested_quantity}
                                          </td>
                                          <td>
                                  <span className="th">
                                    {localization.receiveQuantity}
                                  </span>
                                            {obj.receive_quantity}
                                          </td>

                                          <td>
                                            {Number(obj.requested_quantity) >
                                                Number(obj.receive_quantity) && (
                                                    <Fragment>
                                                      <ConstantInput
                                                          required
                                                          // isStarRequired={true}
                                                          type="number"
                                                          min={1}
                                                          max={
                                                              obj.requested_quantity - obj.receive_quantity
                                                          }
                                                          errorMsg={
                                                            isError
                                                                ? localization.quatityGreaterMsg
                                                                : localization.isRequired
                                                          }
                                                          handleChange={(val) => {
                                                            if (val <= 0) {
                                                              setIsRecQntyValid(
                                                                  'Receive Quantity must be more than zero.'
                                                              );
                                                            } else if (
                                                                obj.requested_quantity -
                                                                obj.receive_quantity >=
                                                                val &&
                                                                val !== ''
                                                            ) {
                                                              const data = {
                                                                material_id: obj.item_id,
                                                                quantity: val,
                                                              };
                                                              handleMaterialData(data);
                                                              setIsRecQntyValid('');
                                                            } else {
                                                              setIsRecQntyValid(
                                                                  'Receive Quantity should be valid.'
                                                              );
                                                            }
                                                          }}
                                                      />
                                                      {isRecQntyValid && (
                                                          <label className={`error d-block`}>
                                                            {isRecQntyValid}
                                                          </label>
                                                      )}
                                                    </Fragment>
                                                )}
                                          </td>
                                        </tr>
                                    );
                                  })}
                              <tr>
                                <td colSpan="5">
                                  <label className={`error ${isError ? 'd-block' : ''}`}>
                                    {localization.quatityGreaterMsg}
                                  </label>
                                </td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                        </FormSection>
                    ) : (
                        <Fragment>
                          <FormSection title={localization.stageStatus}>
                            <div className="form-group">
                              {shouldShowReportAttachment(siteData, match.params.stageId) ? (
                                <DocumentView attachment={siteData.report_url}/>
                              ) : isReportPending ? (
                                <p className="text-muted mb-0">{reportPendingMessage}</p>
                              ) : null}
                            </div>
                          </FormSection>
                          <FormSection title={localization.material}>
                            <table className="panel-table faq-listing">
                              <thead>
                              <tr>
                                <th>{localization.productName}</th>
                                <th>{localization.productCode}</th>
                                <th>{localization.requestedQuantity}</th>
                                <th>{localization.deliveredQuantity}</th>
                              </tr>
                              </thead>
                              <tbody>
                              {materialData &&
                                  materialData.length > 0 &&
                                  materialData.map((obj, index) => {
                                    return (
                                        <tr key={index}>
                                          <td>{obj.item_name}</td>
                                          <td>{obj.item_code_id}</td>
                                          <td>{obj.requested_quantity}</td>
                                          <td>{obj.receive_quantity}</td>
                                        </tr>
                                    );
                                  })}
                              <tr>
                                <td colSpan="5">
                                  <label className={`error ${isError ? 'd-block' : ''}`}>
                                    {localization.quatityGreaterMsg}
                                  </label>
                                </td>
                              </tr>
                              </tbody>
                            </table>
                          </FormSection>
                        </Fragment>
                    )
                  }
                </> */}

              {/* END Old Material Delivery */}

        <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
        >
        <div className="text-center">
        <div className="success">
        <img src={Images?.tick} alt="" />
        </div>
        <h5>{localization.preB2bSuccess}</h5>
        <Link
        to={`${baseUrl}/site-stage/${match.params.id}`}
        className="btn btn-primary mb-4"
        >
      {localization.viewSiteStages}{' '}
        <img src={Images?.ArrowRight} alt="" />
        </Link>
        </div>
        </ModalPop>
        <ModalPop
        title={localization.conf}
        show={statusModal}
        handleModalHide={() => {
        setStatusModal(false);
      }}
        keyboard
        backdrop
        >
        <div className="text-center">
        <div className="success">
        <img src={Images?.tick} alt="" />
        </div>
        <h5>{localization.stateUpdateSuccess}</h5>
        <Link
        to={`${baseUrl}/site-stage/${match.params.id}`}
        className="btn btn-primary mb-4"
        >
      {localization.viewSiteStages}{' '}
        <img src={Images?.ArrowRight} alt="" />
        </Link>
      {(userProfile.attVal && userProfile.attVal[0] && userProfile.attVal[0].lead_id && userProfile.attVal[0].lead_id > 0 )?
        <>
        <Link to="/dashboard/check_out" className="btn btn-danger mb-4">Do You Want to Checkout</Link>
        </>
        :
        null
      }
        </div>
        </ModalPop>
        <ModalPop
        title={localization.notify}
        show={openModal}
        handleModalHide={openHideModal}
        keyboard
        backdrop
        >
        <div className="text-center">
        <DropDownInput
        multipule
        label={localization.toName}
        data={pocListBySiteId}
        required
        isStarRequired={true}
        errorMsg={localization.isRequired}
        getIdValue={(val) => {
        setPocList(val);
      }}
        />
      {showOtherEmail && (
        <ConstantInput
        label={localization.emailAddress}
        regex={Regex.email.test(otherEmail)}
        errorMsg={localization.emailError}
        handleChange={(val) => {
        setOtherEmail(val);
      }}
        type="text"
        />
        )}
        <Button
        className="btn btn-primary mb-4"
        onClick={() => {
        sendMailPoc();
      }}
        >
      {localization.submit} <img src={Images?.ArrowRight} alt="" />
        </Button>
        </div>
        </ModalPop>

        <ModalPop
        title={localization.conf}
        show={modal}
        handleModalHide={emailModalHide}
        keyboard
        backdrop
        >
        <div className="text-center">
        <div className="success">
        <img src={Images?.tick} alt="" />
        </div>
        <h5>{localization.mailSuccessfully}</h5>
        </div>
        </ModalPop>
          </>
      }
    </Layout>
  );
};
export default CivilCheckout;
